// Social Science Course Collection
import { introductionToSociologyCourse } from './introductionToSociologyCourse';
import { introductionToPsychologyCourse } from './introductionToPsychologyCourse';
import { worldHistoryCourse } from './worldHistoryCourse';
import { introductionToPoliticalScienceCourse } from './introductionToPoliticalScienceCourse';
import { culturalAnthropologyCourse } from './culturalAnthropologyCourse';
import { statisticsForSocialSciencesCourse } from './statisticsForSocialSciencesCourse';
import { economicsPrinciplesCourse } from './economicsPrinciplesCourse';
import { criticalThinkingCourse } from './criticalThinkingCourse';
import { socialPsychologyCourse } from './socialPsychologyCourse';

export const socialScienceCourses = [
  introductionToSociologyCourse,
  introductionToPsychologyCourse,
  worldHistoryCourse,
  introductionToPoliticalScienceCourse,
  culturalAnthropologyCourse,
  statisticsForSocialSciencesCourse,
  economicsPrinciplesCourse,
  criticalThinkingCourse,
  socialPsychologyCourse
];

export {
  introductionToSociologyCourse,
  introductionToPsychologyCourse,
  worldHistoryCourse,
  introductionToPoliticalScienceCourse,
  culturalAnthropologyCourse,
  statisticsForSocialSciencesCourse,
  economicsPrinciplesCourse,
  criticalThinkingCourse,
  socialPsychologyCourse
};

// Export course metadata for admin interface
export const socialScienceCoursesMetadata = {
  category: "Social Sciences Curriculum",
  totalCourses: socialScienceCourses.length,
  totalCredits: socialScienceCourses.length * 3, // 3 credits each
  estimatedWeeks: 15, // All courses are 15 weeks
  description: "Comprehensive social science curriculum covering sociology, psychology, history, political science, anthropology, statistics, economics, critical thinking, and social psychology",
  courses: socialScienceCourses.map(course => ({
    id: course.id,
    title: course.title,
    shortDescription: course.shortDescription,
    category: course.category,
    difficulty: course.difficulty,
    duration: course.duration,
    estimatedWeeks: course.estimatedWeeks,
    skills: course.skills,
    prerequisites: course.prerequisites
  }))
};